import api from '../../../api/clinique/_consultations'
import api_soins from '../../../api/clinique/_soin_hospitalisation'

export default {
    getListeTypesConsultations() {
        return new Promise((resolve) => {
            api.getTypesConsultations().then((response) => {
                resolve(response);
            });
        });
    },

    getDureeValiditeConsultation(data) {
        return new Promise((resolve, reject) => {
            api.getDureeValiditeConsultation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getAllFactures() {
        return new Promise((resolve, reject) => {
            api.getAllFactures().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    // recupère soins sans consultation
    getSoinsSansConsultation() {
        return new Promise((resolve, reject) => {
            api_soins.getSoinsSansConsultation().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeConsultations(data) {
        return new Promise((resolve, reject) => {
            api.getListeConsultations(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeRDV() {
        return new Promise((resolve, reject) => {
            api.getListeRDV().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}

